import { Grid } from "@mui/material";
import { titleCase } from "change-case-all";

import FormOne from "./FormOne";
import FormTwo from "./FormTwo";
import { ButtonFooter, PageHeader, Paper } from "../../../components";
import EditButtons from "../../../components/EditButtons";

export default function FormDisplay({
  list,
  editState,
  formikProps,
  setEditState,
}) {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <PageHeader
          pageName={"Brand Details"}
          pageHeader={
            !formikProps.values.brandID
              ? "Let's add brand information"
              : titleCase(formikProps.values.brandName)
          }
          buttons={[
            <EditButtons
              showBackButton={editState ? true : false}
              edit={true}
              editState={editState}
              setEditState={setEditState}
            />,
          ]}
        />
      </Grid>

      <Grid item xs={12}>
        <Paper gridSpacing={4}>
          <FormOne formikProps={formikProps} editState={editState} />

          <FormTwo
            list={list}
            formikProps={formikProps}
            editState={editState}
          />
        </Paper>

        {editState && (
          <Grid item xs={12}>
            <ButtonFooter
              ID={formikProps.values.brandID}
              editState={editState}
              setEditState={setEditState}
              formikProps={formikProps}
            />
          </Grid>
        )}
      </Grid>
    </Grid>
  );
}
